import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';
import { RiskOwnerDTO, RiskOwnerFilters } from '../../models/risk-owner.model';

@Injectable({
  providedIn: "root"
})
export class LaravelRiskOwnerService {


  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
 
      list: environment.baseUrl + "/api/risk_owners",
      show: environment.baseUrl + "/api/risk_owner",
      store: environment.baseUrl + "/api/risk_owner",
      destroy: environment.baseUrl + "/api/risk_owner",
  
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: RiskOwnerFilters,
    includes?: string[]
  ): Observable<ListResultDTO<RiskOwnerDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
  }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<RiskOwnerDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<RiskOwnerDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public getRiskOwnerById(id: number): Observable<RiskOwnerDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<RiskOwnerDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(risk_owner: RiskOwnerDTO): Observable<RiskOwnerDTO> {
    if (risk_owner.id) {
      return this.httpClient.put<RiskOwnerDTO>(`${this.ROUTES.store}`, { risk_owner });
    } else {
      return this.httpClient.post<RiskOwnerDTO>(`${this.ROUTES.store}`, { risk_owner });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
